<template>
  <nav>
    <navbar-logo />
    <navbar-elements />
  </nav>
</template>

<script>
import NavbarLogo from "./NavbarLogo";
import NavbarElements from "./NavbarElements";

export default {
  name: "Navbar",
  components: {
    NavbarLogo,
    NavbarElements
  }
}
</script>

<style lang="scss" scoped>
nav {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 1000px;
  margin: 0 auto;
}

@media only screen and (min-width : 768px) {
  .burger {
    display: none;
  }
}
</style>